









import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "BaseSlowConnection",
  props: {
    isLoading: { type: Boolean, default: false },
    noDescription: { type: Boolean, default: false },
  },
});
